<crowdctrl-unauthenticated-page
  [pageTitle]="'CrowdCTRL ' + appName + ' Login'"
  [showHeader]="false"
  [showFooter]="false"
  [showBrandHeader]="false"
  [stickyFooterOutsideScroll]="true"
  contentClass="login-page-ion-content"
  [contentScrollY]="true"
  [enablePwaPullRefresh]="true"
>
  <div class="unauth-main">
    <div class="login-page-stack">
      <div class="login-shell">
        <div class="login-shell__inner">
          <header class="login-brand-row">
            <h1 class="login-title">CrowdCTRL {{ appName }}</h1>
          </header>
          <p class="login-tagline">Sign in to continue</p>

          @if (errorMessage) {
            <div class="login-error" role="alert">
              {{ errorMessage }}
            </div>
          }

          <div class="login-primary-actions">
            <div class="login-primary-actions__google">
              <crowdctrl-google-sign-in-button
                [fullWidth]="true"
                [isLoading]="activeSignInProvider === 'google'"
                [disabled]="isLoading && activeSignInProvider !== 'google'"
                (signIn)="signInWithGoogle()"
              >
              </crowdctrl-google-sign-in-button>
            </div>
            <button
              type="button"
              class="login-microsoft-btn"
              [disabled]="isLoading"
              aria-label="Sign in with Microsoft"
              (click)="signInWithMicrosoft()"
            >
              <span class="login-microsoft-btn__content">
                @if (activeSignInProvider === 'microsoft') {
                  <span class="login-microsoft-btn__spinner" aria-hidden="true"></span>
                  <span class="login-microsoft-btn__text">Signing in...</span>
                } @else {
                  <svg
                    class="login-microsoft-btn__logo"
                    viewBox="0 0 23 23"
                    xmlns="http://www.w3.org/2000/svg"
                    aria-hidden="true"
                  >
                    <path fill="#f65314" d="M1 1h10v10H1z" />
                    <path fill="#7cbb00" d="M12 1h10v10H12z" />
                    <path fill="#00a4ef" d="M1 12h10v10H1z" />
                    <path fill="#ffbb00" d="M12 12h10v10H12z" />
                  </svg>
                  <span class="login-microsoft-btn__text">Sign in with Microsoft</span>
                }
              </span>
            </button>

            <nav class="login-primary-actions__how" aria-label="About CrowdCTRL">
              <ion-button
                fill="clear"
                expand="block"
                class="login-how-it-works-btn"
                href="/about"
                (click)="unauthNav.forward($event, '/about')"
              >
                How it works
                <ion-icon slot="end" name="arrow-forward-outline" aria-hidden="true"></ion-icon>
              </ion-button>
            </nav>
          </div>
        </div>
      </div>
    </div>
  </div>

  <footer class="login-page-footer unauth-sticky-footer">
    <p class="login-legal">
      © 2025 Crowd CTRL is a registered business name of A.C.N. 690 862 778 Pty Ltd | ABN 30 690 862
      778
    </p>
    <nav class="login-footer-links" aria-label="Legal and contact links">
      <a
        href="/privacy-policy"
        class="login-footer-contact__link"
        (click)="unauthNav.forward($event, '/privacy-policy')"
        >Privacy Policy</a
      >
      <span class="login-footer-sep" aria-hidden="true">•</span>
      <a
        href="/terms"
        class="login-footer-contact__link"
        (click)="unauthNav.forward($event, '/terms')"
        >Terms</a
      >
      <span class="login-footer-sep" aria-hidden="true">•</span>
      @if (contactMailtoHref) {
        <a [href]="contactMailtoHref" class="login-footer-contact__link">Contact us</a>
      } @else {
        <a
          href="/contact"
          class="login-footer-contact__link"
          (click)="unauthNav.forward($event, '/contact')"
          >Contact us</a
        >
      }
    </nav>
  </footer>
</crowdctrl-unauthenticated-page>
